<template>
  <route-details-modal class="route-details-message" :hide-actions="true" :route-details="route" />
</template>

<script>
import RouteDetailsModal from '../../modals/RouteDetailsModal.vue'

export default {
  components: {
    RouteDetailsModal
  },
  props: {
    message: {
      type: Object,
      default: () => ({})
    },
    route: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style lang="sass">
.route-details-message
  box-shadow: none !important
  margin-bottom: 50px
  padding: 0 !important
  .route-details-home
    padding: 0 !important
    margin: 0 !important
  .route-details-close
    display: none
  #routeDetailsHome
    padding: 0
    margin: 0
    min-height: auto !important
  .route-name,
  .route-state,
  .route-name span,
  .client-name
    padding: 0
    margin-bottom: 3px
    font-size: 14px
    text-align: center

  @media only screen and (max-width: 1280px)
    .route-homes-wrapper
      width: 100% !important
      max-width: 100% !important
      flex-basis: 100% !important

    .route-map
      width: 100% !important
      max-width: 100% !important
      flex-basis: 100% !important
      margin: 0 0 20px 0 !important
      #map
        height: auto !important
</style>
